var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        "no-primary-button": "",
        closeButtonText: _vm._f("gettext")("Close"),
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "ContractServiceEditor",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  ref: "mainForm",
                  staticClass: "row",
                  attrs: { id: _vm.formId, name: "contract" },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpCol",
                    [
                      _c("ItpText", {
                        attrs: {
                          strong: "",
                          text: _vm._f("pgettext")(
                            "Service",
                            "ContractServiceEditor"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            name: "service",
                            label: _vm._f("pgettext")(
                              "Service",
                              "ContractService"
                            ),
                            labelColsMd: "3",
                            contentColsMd: "9",
                            labelAlign: _vm.labelAlign,
                            helpTooltip: _vm._f("pgettext")(
                              "Select the product or service the invoice line refers to.",
                              "ContractService|Tooltip"
                            ),
                            required: ""
                          }
                        },
                        [
                          _c("ItpFormSelect2", {
                            attrs: {
                              name: "client",
                              "bind-object": "",
                              options: _vm.services,
                              textField: "name",
                              readonly: _vm.isServiceReadonly
                            },
                            on: {
                              optionSelected: function($event) {
                                return _vm.evh_3054425420812800_optionSelected(
                                  $event,
                                  {}
                                )
                              }
                            },
                            model: {
                              value: _vm.item.service,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "service", $$v)
                              },
                              expression: "item.service"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            labelColsMd: "3",
                            contentColsMd: "9",
                            name: "invoice_group_id",
                            label: _vm._f("pgettext")(
                              "Invoice Group",
                              "ContractService"
                            ),
                            labelAlign: _vm.labelAlign,
                            helpTooltip: _vm._f("pgettext")(
                              "The invoice group this service belongs to.",
                              "ContractService|Tooltip"
                            )
                          }
                        },
                        [
                          _c("ItpFormSelect2", {
                            attrs: {
                              name: "invoice_group_id",
                              multiple: _vm.b_7307096920626688_multiple,
                              options: _vm.invoiceGroups,
                              valueField: "id",
                              textField: "name",
                              clearable: "",
                              readonly: _vm.isServiceReadonly
                            },
                            model: {
                              value: _vm.item.invoice_group_id,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "invoice_group_id", $$v)
                              },
                              expression: "item.invoice_group_id"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            labelColsMd: "3",
                            name: "intermediated_service",
                            label: _vm._f("pgettext")(
                              "Intermediated service",
                              "ContractService"
                            ),
                            labelAlign: _vm.labelAlign,
                            helpTooltip: _vm._f("pgettext")(
                              "Select this option if the service is provided via an intermediary party.",
                              "ContractService|Tooltip"
                            )
                          }
                        },
                        [
                          _c("ItpFormCheckbox", {
                            attrs: {
                              name: "intermediated_service",
                              readonly: _vm.isServiceReadonly
                            },
                            model: {
                              value: _vm.item.intermediated_service,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "intermediated_service", $$v)
                              },
                              expression: "item.intermediated_service"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            name: "valid_from",
                            label: _vm._f("pgettext")(
                              "Valid from",
                              "ContractService"
                            ),
                            labelColsMd: "3",
                            contentColsMd: "4",
                            labelAlign: _vm.labelAlign,
                            helpTooltip: _vm._f("pgettext")(
                              "Specifies the start date of the service period.",
                              "ContractService|Tooltip"
                            )
                          }
                        },
                        [
                          _c("ItpFormDatetime", {
                            attrs: {
                              name: "valid_from",
                              required: "",
                              readonly: _vm.isServiceReadonly
                            },
                            model: {
                              value: _vm.item.valid_from,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "valid_from", $$v)
                              },
                              expression: "item.valid_from"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            name: "valid_to",
                            label: _vm._f("pgettext")(
                              "Valid to",
                              "ContractService"
                            ),
                            labelColsMd: "3",
                            contentColsMd: "4",
                            labelAlign: _vm.labelAlign,
                            helpTooltip: _vm._f("pgettext")(
                              "The service end date. Set only if it's different from the contract's end date.",
                              "ContractService|Tooltip"
                            )
                          }
                        },
                        [
                          _c("ItpFormDatetime", {
                            attrs: {
                              name: "valid_to",
                              readonly: _vm.isServiceReadonly
                            },
                            model: {
                              value: _vm.item.valid_to,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "valid_to", $$v)
                              },
                              expression: "item.valid_to"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            name: "valid_to",
                            label: _vm._f("pgettext")(
                              "Description",
                              "ContractService"
                            ),
                            labelColsMd: "3",
                            contentColsMd: "9",
                            labelAlign: _vm.labelAlign,
                            helpTooltip: _vm._f("pgettext")(
                              "Internal notes for reference only. Not visible externally.",
                              "ContractService|Tooltip"
                            )
                          }
                        },
                        [
                          _c("ItpFormTextarea", {
                            attrs: {
                              name: "description",
                              readonly: _vm.isServiceReadonly,
                              rows: "5"
                            },
                            model: {
                              value: _vm.item.description,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "description", $$v)
                              },
                              expression: "item.description"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "fieldset",
                        [
                          _c("legend", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("pgettext")(
                                    "Invoicing",
                                    "ContractServiceEditor|Section"
                                  )
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "6",
                                name: "billing_category",
                                label: _vm._f("pgettext")(
                                  "Billing category",
                                  "ContractService"
                                ),
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The invoice category this service should be assigned to when billed. New values entered will be saved for future use.",
                                  "ContractService|Help|BillingCategory"
                                )
                              }
                            },
                            [
                              _c("ItpFormSelect2", {
                                attrs: {
                                  name: "billing_category",
                                  taggable: "",
                                  options: _vm.billingCategories,
                                  readonly: _vm.item.isReadonly,
                                  valueField: "name",
                                  textField: "name"
                                },
                                model: {
                                  value: _vm.item.billing_category,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "billing_category", $$v)
                                  },
                                  expression: "item.billing_category"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "name",
                                label: _vm._f("pgettext")(
                                  "Name",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "This text will appear on the invice line.",
                                  "ContractService|Tooltip"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  name: "name",
                                  required: "",
                                  readonly: _vm.isServiceReadonly
                                },
                                model: {
                                  value: _vm.item.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "name", $$v)
                                  },
                                  expression: "item.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "name",
                                label: _vm._f("pgettext")(
                                  "Name(s)",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "This text will appear on the invice line.",
                                  "ContractService|Tooltip"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("UCContractServiceItemNameEditor", {
                                attrs: { readonly: _vm.isServiceReadonly },
                                model: {
                                  value: _vm.item.invoice_item_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "invoice_item_name", $$v)
                                  },
                                  expression: "item.invoice_item_name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            { attrs: { labelColsMd: "3", contentColsMd: "9" } },
                            [_c("hr", { staticClass: "dots" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "invoice_notes",
                                label: _vm._f("pgettext")(
                                  "Invoice notes",
                                  "ContractServiceFee"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "Note to display on the invoice line.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ItpFormTextarea", {
                                attrs: {
                                  name: "fee_notes",
                                  readonly: _vm.isServiceReadonly
                                },
                                model: {
                                  value: _vm.item.invoice_notes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "invoice_notes", $$v)
                                  },
                                  expression: "item.invoice_notes"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "transaction_notes",
                                label: _vm._f("pgettext")(
                                  "Additional invoice notes",
                                  "ContractServiceFee"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "Note to display on the invoice line conditionally.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("TransactionNotesEditor", {
                                attrs: { readonly: _vm.isServiceReadonly },
                                model: {
                                  value: _vm.item.transaction_notes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "transaction_notes", $$v)
                                  },
                                  expression: "item.transaction_notes"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "billing_frequency",
                                label: _vm._f("pgettext")(
                                  "Billing frequency",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "3",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The cycle length of issuing the invoices.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("BillingFrequencySelector", {
                                attrs: { readonly: _vm.isServiceReadonly },
                                model: {
                                  value: _vm.item.billing_frequency,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "billing_frequency", $$v)
                                  },
                                  expression: "item.billing_frequency"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "billing_date_rule",
                                label: _vm._f("pgettext")(
                                  "Billing date rule",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The cycle length of issuing the invoices.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("BillingDateRuleFields", {
                                attrs: { readonly: _vm.isServiceReadonly },
                                model: {
                                  value: _vm.item.billing_date_rule,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "billing_date_rule", $$v)
                                  },
                                  expression: "item.billing_date_rule"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            { attrs: { labelColsMd: "3", contentColsMd: "9" } },
                            [_c("hr", { staticClass: "dots" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "due_date_rule",
                                label: _vm._f("pgettext")(
                                  "Due date rule",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The rule of calculating the payment dates.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("DueDateRuleFields", {
                                attrs: { readonly: _vm.isServiceReadonly },
                                model: {
                                  value: _vm.item.due_date_rule,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "due_date_rule", $$v)
                                  },
                                  expression: "item.due_date_rule"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            { attrs: { labelColsMd: "3", contentColsMd: "9" } },
                            [_c("hr", { staticClass: "dots" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "billing_currency",
                                label: _vm._f("pgettext")(
                                  "Billing currency",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "3",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The currency to use on the invoice.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("BillingCurrencySelector", {
                                attrs: { readonly: _vm.isServiceReadonly },
                                model: {
                                  value: _vm.item.billing_currency,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "billing_currency", $$v)
                                  },
                                  expression: "item.billing_currency"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "exchange_rate_source",
                                label: _vm._f("pgettext")(
                                  "Exchange rate source",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "3",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The currency exchange rate's provider.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ExchangeRateSourceSelector", {
                                attrs: { readonly: _vm.isServiceReadonly },
                                model: {
                                  value: _vm.item.exchange_rate_source,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.item,
                                      "exchange_rate_source",
                                      $$v
                                    )
                                  },
                                  expression: "item.exchange_rate_source"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "exchange_rate_date_rule",
                                label: _vm._f("pgettext")(
                                  "Exchange rate date rule",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The date used to determine the exchange rate for billing purposes.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ExchangeRateDateRuleFields", {
                                attrs: { readonly: _vm.isServiceReadonly },
                                model: {
                                  value: _vm.item.exchange_rate_date_rule,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.item,
                                      "exchange_rate_date_rule",
                                      $$v
                                    )
                                  },
                                  expression: "item.exchange_rate_date_rule"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.displayFee ? _c("hr") : _vm._e(),
                      _vm._v(" "),
                      _vm.displayFee
                        ? _c("ItpText", {
                            attrs: {
                              strong: "",
                              text: _vm._f("pgettext")(
                                "Fee",
                                "ContractServiceEditor"
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.displayFeeDates
                        ? _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "fee_valid_from",
                                label: _vm._f("pgettext")(
                                  "Valid from",
                                  "ContractServiceFee"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "3",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The start date of the fee.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ItpFormDatetime", {
                                attrs: { name: "valid_from", required: "" },
                                model: {
                                  value: _vm.feeItem.valid_from,
                                  callback: function($$v) {
                                    _vm.$set(_vm.feeItem, "valid_from", $$v)
                                  },
                                  expression: "feeItem.valid_from"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.displayFeeDates
                        ? _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "fee_valid_to",
                                label: _vm._f("pgettext")(
                                  "Valid to",
                                  "ContractServiceFee"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "3",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The end date of the fee. Set only if it's different from the service's end date.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ItpFormDatetime", {
                                attrs: { name: "valid_to" },
                                model: {
                                  value: _vm.feeItem.valid_to,
                                  callback: function($$v) {
                                    _vm.$set(_vm.feeItem, "valid_to", $$v)
                                  },
                                  expression: "feeItem.valid_to"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.displayFee
                        ? _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "fee_valid_to",
                                label: _vm._f("pgettext")(
                                  "Amount",
                                  "ContractServiceFee"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "5",
                                labelAlign: _vm.labelAlign,
                                contentClass: "input-group",
                                helpTooltip: _vm._f("pgettext")(
                                  "The price per unit of the fee.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                staticClass: "col-9",
                                attrs: {
                                  type: "number",
                                  name: "fee_amount",
                                  required: ""
                                },
                                model: {
                                  value: _vm.feeItem.amount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.feeItem, "amount", $$v)
                                  },
                                  expression: "feeItem.amount"
                                }
                              }),
                              _vm._v(" "),
                              _c("ItpFormSelect", {
                                staticClass: "col-3",
                                attrs: {
                                  name: "currency",
                                  options: _vm.currencies,
                                  textField: "code",
                                  valueField: "code",
                                  required: ""
                                },
                                model: {
                                  value: _vm.feeItem.currency,
                                  callback: function($$v) {
                                    _vm.$set(_vm.feeItem, "currency", $$v)
                                  },
                                  expression: "feeItem.currency"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.displayFee
                        ? _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "fee_unit",
                                label: _vm._f("pgettext")(
                                  "Invoice unit",
                                  "ContractServiceFee"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "2",
                                labelAlign: _vm.labelAlign,
                                contentClass: "input-group",
                                helpTooltip: _vm._f("pgettext")(
                                  "The unit used for billing.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "fee_unit", required: "" },
                                model: {
                                  value: _vm.feeItem.unit,
                                  callback: function($$v) {
                                    _vm.$set(_vm.feeItem, "unit", $$v)
                                  },
                                  expression: "feeItem.unit"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.displayFee
                        ? _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "fee_quantity",
                                label: _vm._f("pgettext")(
                                  "Quantity",
                                  "ContractServiceFee"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "2",
                                labelAlign: _vm.labelAlign,
                                contentClass: "input-group",
                                helpTooltip: _vm._f("pgettext")(
                                  "The quantity to bill for each period.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { type: "number", name: "fee_quantity" },
                                model: {
                                  value: _vm.feeItem.quantity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.feeItem, "quantity", $$v)
                                  },
                                  expression: "feeItem.quantity"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.displayFee
                        ? _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "fee_unit_of_quantity",
                                label: _vm._f("pgettext")(
                                  "Unit of quantity",
                                  "ContractServiceFee"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "2",
                                labelAlign: _vm.labelAlign,
                                contentClass: "input-group",
                                helpTooltip: _vm._f("pgettext")(
                                  "The unit of quantity - if different from the billing quantity.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "fee_unit_of_quantity" },
                                model: {
                                  value: _vm.feeItem.unit_of_quantity,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.feeItem,
                                      "unit_of_quantity",
                                      $$v
                                    )
                                  },
                                  expression: "feeItem.unit_of_quantity"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.displayFee
                        ? _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "fee_inflation_indexed",
                                label: _vm._f("pgettext")(
                                  "Inflation indexed",
                                  "ContractServiceFee"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "Indicates if the unit price should be automatically adjusted based on indexation rules.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: { name: "fee_inflation_indexed" },
                                model: {
                                  value: _vm.feeItem.inflation_indexed,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.feeItem,
                                      "inflation_indexed",
                                      $$v
                                    )
                                  },
                                  expression: "feeItem.inflation_indexed"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            name: "transaction_notes",
                            label: _vm._f("pgettext")(
                              "Invoice notes",
                              "ContractServiceFee"
                            ),
                            labelColsMd: "3",
                            contentColsMd: "9",
                            labelAlign: _vm.labelAlign,
                            helpTooltip: _vm._f("pgettext")(
                              "Note to display on the invoice line.",
                              "ContractService|Tooltip"
                            )
                          }
                        },
                        [
                          _c("TransactionNotesEditor", {
                            model: {
                              value: _vm.feeItem.transaction_notes,
                              callback: function($$v) {
                                _vm.$set(_vm.feeItem, "transaction_notes", $$v)
                              },
                              expression: "feeItem.transaction_notes"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.displayFee
                        ? _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "fee_notes",
                                label: _vm._f("pgettext")(
                                  "Notes",
                                  "ContractServiceFee"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "Notes for internal use only.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ItpFormTextarea", {
                                attrs: { name: "fee_notes" },
                                model: {
                                  value: _vm.feeItem.notes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.feeItem, "notes", $$v)
                                  },
                                  expression: "feeItem.notes"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mode === "editServiceFee" && !_vm.feeItem.locked
                        ? _c("ItpButton", {
                            attrs: {
                              text: _vm._f("pgettext")(
                                "Lock Service Fee",
                                "Button"
                              ),
                              variant: "light",
                              icon: "fa-lock",
                              spinning: _vm.actions.lockServiceFee.isRunning
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_4704362798300200_clickPreventStop(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _vm.mode === "editService" && !_vm.service.locked
                ? _c("ItpButton", {
                    attrs: {
                      text: _vm._f("pgettext")("Lock Service", "Button"),
                      variant: "light",
                      icon: "fa-lock",
                      spinning: _vm.actions.lockService.isRunning
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_1548630417156826_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "editService" && _vm.isDeletable
                ? _c("ItpButton", {
                    staticClass: "mr-auto",
                    attrs: {
                      text: _vm._f("pgettext")("Delete Service", "Button"),
                      variant: "danger",
                      icon: "fa-times",
                      spinning: _vm.actions.deleteService.isRunning
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_1419464017721962_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "editServiceFee" && _vm.isDeletable
                ? _c("ItpButton", {
                    staticClass: "mr-auto",
                    attrs: {
                      text: _vm._f("pgettext")("Delete Fee", "Button"),
                      variant: "danger",
                      icon: "fa-times",
                      spinning: _vm.actions.deleteServiceFee.isRunning
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_2186679009640457_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isEditable
                ? _c("ItpButton", {
                    attrs: {
                      text: _vm._f("pgettext")("Save", "Button"),
                      type: "submit",
                      form: _vm.formId,
                      variant: "primary",
                      icon: "fa-save",
                      spinning: _vm.actions.save.isRunning
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: { text: _vm._f("gettext")("Close"), variant: "default" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1037450307673255_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }